module.exports = __webpack_public_path__ + "img/tuts-rating-slider-desktop-7.c750b122.png";